import { FC } from 'react';
import { useForm } from 'react-hook-form';
import FormCheckBoxesRequired from 'containers/Login/components/FormCheckboxesRequired';
import Button from 'components/Button';
import { Trans, useTranslation } from 'react-i18next';
import FormPhone, {
  DEFAULT_PHONE_PREFIX,
  Fields,
  Fields as PhoneFields,
} from 'components/Form/Phone';

type Phone = {
  phone: string;
  prefix: string;
};

export interface Props {
  onSend: (phone: Phone) => void;
}

const PhoneForm: FC<Props> = ({ onSend }) => {
  const { t } = useTranslation();
  const { register, control, errors, handleSubmit, watch } = useForm({
    mode: 'onSubmit',
  });

  const watchFields = watch([
    PhoneFields.phone.name,
    PhoneFields.prefix.name,
    'terms',
    'privacy',
  ]);

  const onSubmit = ({ phone, prefix }: Phone) => {
    phone = phone.replace(/[^0-9]/g, '');
    onSend && onSend({ phone, prefix: prefix ?? DEFAULT_PHONE_PREFIX });
  };

  return (
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
      <FormPhone
        register={register}
        control={control}
        isDirty={!!watchFields[Fields.phone.name]}
        errors={errors[Fields.phone.name]}
      />
      <FormCheckBoxesRequired
        register={register}
        terms={watchFields['terms']}
        privacy={watchFields['privacy']}
        errors={errors}
      />
      <Button
        className="ml-auto"
        disabled={!watchFields[PhoneFields.phone.name]}
      >
        {t('login__send_code_form_button')}
      </Button>
      <div
        data-testid="patient-redirect"
        className="hidden my-12 text-base text-center text-dark lg:block"
      >
        <Trans i18nKey="login__patient_platform_link">
          ¿Eres paciente?
          <a
            href="https://eat.emmasolutions.net/?entw=dec1fe43825d340d60a736e9ca73fade"
            className="text-primary hover:text-primary-dark hover:underline"
          >
            Entra en tu zona
          </a>
        </Trans>
      </div>
    </form>
  );
};

export default PhoneForm;
